export default "__VITE_ASSET__CC6baWRP__"